import { resolveLocalUrl } from './localUrlResolver';

const SAFE_URL_SCHEMES = ['http:', 'https:', 'blob:', 'data:'];

type CanvasImageToFileParams = {
  url: string;
  imageId: string;
};

/**
 * Fetch a canvas image URL (`data:` base64, `blob:`, or remote) into a File so
 * it can be uploaded to CDN. Returns null if the URL scheme is unusable.
 */
const canvasImageToFile = async ({
  url,
  imageId,
}: CanvasImageToFileParams): Promise<File | null> => {
  const resolvedUrl = resolveLocalUrl(url);

  let parsed: URL;
  try {
    parsed = new URL(resolvedUrl);
  } catch {
    return null;
  }

  if (!SAFE_URL_SCHEMES.includes(parsed.protocol)) return null;

  const response = await fetch(resolvedUrl);
  if (!response.ok) return null;

  const blob = await response.blob();
  return new File([blob], `canvas-${imageId}.png`, { type: 'image/png' });
};

export default canvasImageToFile;
